import Card, { CardContent } from "../Card"
import SkeletonBase from "./SkeletonBase"

/**
 * Skeleton pour CertificatePreview
 * Reproduit la structure de CertificatePreview.jsx
 */
export default function CertificateSkeleton() {
  return (
    <Card className="overflow-hidden">
      {/* Image skeleton */}
      <div className="relative">
        <SkeletonBase 
          className="w-full h-48" 
          height="12rem"
          rounded="rounded-none"
        />
        {/* Badge skeleton */}
        <div className="absolute top-3 right-3">
          <SkeletonBase 
            className="w-16 h-6 rounded-full" 
            width="4rem"
            height="1.5rem"
            rounded="rounded-full"
          />
        </div>
      </div>

      <CardContent className="p-4">
        <div className="space-y-2">
          {/* Title skeleton */}
          <div className="flex items-start justify-between gap-2">
            <SkeletonBase 
              className="h-5 flex-1" 
              height="1.25rem"
            />
            <SkeletonBase 
              className="w-4 h-4 rounded-full" 
              width="1rem"
              height="1rem"
              rounded="rounded-full"
            />
          </div>

          {/* Certificate number skeleton */}
          <SkeletonBase 
            className="w-32 h-4" 
            width="8rem"
            height="1rem"
            rounded="rounded"
          />

          {/* Date skeleton */}
          <SkeletonBase 
            className="w-40 h-4" 
            width="10rem"
            height="1rem"
          />

          {/* Message skeleton */}
          <div className="mt-2">
            <SkeletonBase 
              className="w-full h-12" 
              height="3rem"
              rounded="rounded-lg"
            />
          </div>

          {/* Buttons skeleton */}
          <div className="flex items-center gap-2 pt-2">
            <SkeletonBase 
              className="flex-1 h-9" 
              height="2.25rem"
              rounded="rounded-md"
            />
            <SkeletonBase 
              className="w-9 h-9 rounded-full" 
              width="2.25rem"
              height="2.25rem"
              rounded="rounded-full"
            />
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
